import { render, staticRenderFns } from "./AddEvent.vue?vue&type=template&id=1fa7a04a&"
import script from "./js/add-event.js?vue&type=script&lang=js&"
export * from "./js/add-event.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports